@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package kotlinproject.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi

private object CommonMainDrawable0 {
  public val Icons8: DrawableResource by 
      lazy { init_Icons8() }

  public val as_logo1: DrawableResource by 
      lazy { init_as_logo1() }

  public val as_logo_small: DrawableResource by 
      lazy { init_as_logo_small() }

  public val as_logo_transparent: DrawableResource by 
      lazy { init_as_logo_transparent() }

  public val avatargreen: DrawableResource by 
      lazy { init_avatargreen() }

  public val bg_input_gold: DrawableResource by 
      lazy { init_bg_input_gold() }

  public val bg_input_white: DrawableResource by 
      lazy { init_bg_input_white() }

  public val brain: DrawableResource by 
      lazy { init_brain() }

  public val btn_custom: DrawableResource by 
      lazy { init_btn_custom() }

  public val btn_difficulty_normal: DrawableResource by 
      lazy { init_btn_difficulty_normal() }

  public val btn_difficulty_selected: DrawableResource by 
      lazy { init_btn_difficulty_selected() }

  public val btn_difficulty_selector: DrawableResource by 
      lazy { init_btn_difficulty_selector() }

  public val btn_login_glass: DrawableResource by 
      lazy { init_btn_login_glass() }

  public val btn_login_glass_selected: DrawableResource by 
      lazy { init_btn_login_glass_selected() }

  public val btn_mode_selector: DrawableResource by 
      lazy { init_btn_mode_selector() }

  public val compose_multiplatform: DrawableResource by 
      lazy { init_compose_multiplatform() }

  public val elephant: DrawableResource by 
      lazy { init_elephant() }

  public val flag: DrawableResource by 
      lazy { init_flag() }

  public val flag_de: DrawableResource by 
      lazy { init_flag_de() }

  public val flag_en: DrawableResource by 
      lazy { init_flag_en() }

  public val flag_es: DrawableResource by 
      lazy { init_flag_es() }

  public val flag_fr: DrawableResource by 
      lazy { init_flag_fr() }

  public val flag_it: DrawableResource by 
      lazy { init_flag_it() }

  public val flag_sr: DrawableResource by 
      lazy { init_flag_sr() }

  public val giraffe: DrawableResource by 
      lazy { init_giraffe() }

  public val ic_help_circle: DrawableResource by 
      lazy { init_ic_help_circle() }

  public val ic_launcher_background: DrawableResource by 
      lazy { init_ic_launcher_background() }

  public val ic_launcher_foreground: DrawableResource by 
      lazy { init_ic_launcher_foreground() }

  public val ic_radio_selector: DrawableResource by 
      lazy { init_ic_radio_selector() }

  public val koala: DrawableResource by 
      lazy { init_koala() }

  public val leo: DrawableResource by 
      lazy { init_leo() }

  public val list_selector: DrawableResource by 
      lazy { init_list_selector() }

  public val loki: DrawableResource by 
      lazy { init_loki() }

  public val raccoon: DrawableResource by 
      lazy { init_raccoon() }

  public val refresh: DrawableResource by 
      lazy { init_refresh() }

  public val refresh_frame: DrawableResource by 
      lazy { init_refresh_frame() }

  public val robot: DrawableResource by 
      lazy { init_robot() }

  public val spinner_item_background: DrawableResource by 
      lazy { init_spinner_item_background() }

  public val squirrel: DrawableResource by 
      lazy { init_squirrel() }

  public val thunder: DrawableResource by 
      lazy { init_thunder() }

  public val tooltip_bg: DrawableResource by 
      lazy { init_tooltip_bg() }

  public val warmachine: DrawableResource by 
      lazy { init_warmachine() }
}

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("Icons8", CommonMainDrawable0.Icons8)
  map.put("as_logo1", CommonMainDrawable0.as_logo1)
  map.put("as_logo_small", CommonMainDrawable0.as_logo_small)
  map.put("as_logo_transparent", CommonMainDrawable0.as_logo_transparent)
  map.put("avatargreen", CommonMainDrawable0.avatargreen)
  map.put("bg_input_gold", CommonMainDrawable0.bg_input_gold)
  map.put("bg_input_white", CommonMainDrawable0.bg_input_white)
  map.put("brain", CommonMainDrawable0.brain)
  map.put("btn_custom", CommonMainDrawable0.btn_custom)
  map.put("btn_difficulty_normal", CommonMainDrawable0.btn_difficulty_normal)
  map.put("btn_difficulty_selected", CommonMainDrawable0.btn_difficulty_selected)
  map.put("btn_difficulty_selector", CommonMainDrawable0.btn_difficulty_selector)
  map.put("btn_login_glass", CommonMainDrawable0.btn_login_glass)
  map.put("btn_login_glass_selected", CommonMainDrawable0.btn_login_glass_selected)
  map.put("btn_mode_selector", CommonMainDrawable0.btn_mode_selector)
  map.put("compose_multiplatform", CommonMainDrawable0.compose_multiplatform)
  map.put("elephant", CommonMainDrawable0.elephant)
  map.put("flag", CommonMainDrawable0.flag)
  map.put("flag_de", CommonMainDrawable0.flag_de)
  map.put("flag_en", CommonMainDrawable0.flag_en)
  map.put("flag_es", CommonMainDrawable0.flag_es)
  map.put("flag_fr", CommonMainDrawable0.flag_fr)
  map.put("flag_it", CommonMainDrawable0.flag_it)
  map.put("flag_sr", CommonMainDrawable0.flag_sr)
  map.put("giraffe", CommonMainDrawable0.giraffe)
  map.put("ic_help_circle", CommonMainDrawable0.ic_help_circle)
  map.put("ic_launcher_background", CommonMainDrawable0.ic_launcher_background)
  map.put("ic_launcher_foreground", CommonMainDrawable0.ic_launcher_foreground)
  map.put("ic_radio_selector", CommonMainDrawable0.ic_radio_selector)
  map.put("koala", CommonMainDrawable0.koala)
  map.put("leo", CommonMainDrawable0.leo)
  map.put("list_selector", CommonMainDrawable0.list_selector)
  map.put("loki", CommonMainDrawable0.loki)
  map.put("raccoon", CommonMainDrawable0.raccoon)
  map.put("refresh", CommonMainDrawable0.refresh)
  map.put("refresh_frame", CommonMainDrawable0.refresh_frame)
  map.put("robot", CommonMainDrawable0.robot)
  map.put("spinner_item_background", CommonMainDrawable0.spinner_item_background)
  map.put("squirrel", CommonMainDrawable0.squirrel)
  map.put("thunder", CommonMainDrawable0.thunder)
  map.put("tooltip_bg", CommonMainDrawable0.tooltip_bg)
  map.put("warmachine", CommonMainDrawable0.warmachine)
}

internal val Res.drawable.Icons8: DrawableResource
  get() = CommonMainDrawable0.Icons8

private fun init_Icons8(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:Icons8",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/Icons8.zip", -1, -1),
    )
)

internal val Res.drawable.as_logo1: DrawableResource
  get() = CommonMainDrawable0.as_logo1

private fun init_as_logo1(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:as_logo1",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/as_logo1.png", -1, -1),
    )
)

internal val Res.drawable.as_logo_small: DrawableResource
  get() = CommonMainDrawable0.as_logo_small

private fun init_as_logo_small(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:as_logo_small",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/as_logo_small.jpeg", -1, -1),
    )
)

internal val Res.drawable.as_logo_transparent: DrawableResource
  get() = CommonMainDrawable0.as_logo_transparent

private fun init_as_logo_transparent(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:as_logo_transparent",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/as_logo_transparent.png", -1, -1),
    )
)

internal val Res.drawable.avatargreen: DrawableResource
  get() = CommonMainDrawable0.avatargreen

private fun init_avatargreen(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:avatargreen",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/avatargreen.png", -1, -1),
    )
)

internal val Res.drawable.bg_input_gold: DrawableResource
  get() = CommonMainDrawable0.bg_input_gold

private fun init_bg_input_gold(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:bg_input_gold",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/bg_input_gold.xml", -1, -1),
    )
)

internal val Res.drawable.bg_input_white: DrawableResource
  get() = CommonMainDrawable0.bg_input_white

private fun init_bg_input_white(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:bg_input_white",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/bg_input_white.xml", -1, -1),
    )
)

internal val Res.drawable.brain: DrawableResource
  get() = CommonMainDrawable0.brain

private fun init_brain(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:brain",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/brain.png", -1, -1),
    )
)

internal val Res.drawable.btn_custom: DrawableResource
  get() = CommonMainDrawable0.btn_custom

private fun init_btn_custom(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:btn_custom",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/btn_custom.xml", -1, -1),
    )
)

internal val Res.drawable.btn_difficulty_normal: DrawableResource
  get() = CommonMainDrawable0.btn_difficulty_normal

private fun init_btn_difficulty_normal(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:btn_difficulty_normal",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/btn_difficulty_normal.xml", -1, -1),
    )
)

internal val Res.drawable.btn_difficulty_selected: DrawableResource
  get() = CommonMainDrawable0.btn_difficulty_selected

private fun init_btn_difficulty_selected(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:btn_difficulty_selected",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/btn_difficulty_selected.xml", -1, -1),
    )
)

internal val Res.drawable.btn_difficulty_selector: DrawableResource
  get() = CommonMainDrawable0.btn_difficulty_selector

private fun init_btn_difficulty_selector(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:btn_difficulty_selector",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/btn_difficulty_selector.xml", -1, -1),
    )
)

internal val Res.drawable.btn_login_glass: DrawableResource
  get() = CommonMainDrawable0.btn_login_glass

private fun init_btn_login_glass(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:btn_login_glass",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/btn_login_glass.xml", -1, -1),
    )
)

internal val Res.drawable.btn_login_glass_selected: DrawableResource
  get() = CommonMainDrawable0.btn_login_glass_selected

private fun init_btn_login_glass_selected(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:btn_login_glass_selected",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/btn_login_glass_selected.xml", -1, -1),
    )
)

internal val Res.drawable.btn_mode_selector: DrawableResource
  get() = CommonMainDrawable0.btn_mode_selector

private fun init_btn_mode_selector(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:btn_mode_selector",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/btn_mode_selector.xml", -1, -1),
    )
)

internal val Res.drawable.compose_multiplatform: DrawableResource
  get() = CommonMainDrawable0.compose_multiplatform

private fun init_compose_multiplatform(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:compose_multiplatform",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/compose-multiplatform.xml", -1, -1),
    )
)

internal val Res.drawable.elephant: DrawableResource
  get() = CommonMainDrawable0.elephant

private fun init_elephant(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:elephant",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/elephant.png", -1, -1),
    )
)

internal val Res.drawable.flag: DrawableResource
  get() = CommonMainDrawable0.flag

private fun init_flag(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:flag",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/flag.png", -1, -1),
    )
)

internal val Res.drawable.flag_de: DrawableResource
  get() = CommonMainDrawable0.flag_de

private fun init_flag_de(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:flag_de",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/flag_de.png", -1, -1),
    )
)

internal val Res.drawable.flag_en: DrawableResource
  get() = CommonMainDrawable0.flag_en

private fun init_flag_en(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:flag_en",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/flag_en.png", -1, -1),
    )
)

internal val Res.drawable.flag_es: DrawableResource
  get() = CommonMainDrawable0.flag_es

private fun init_flag_es(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:flag_es",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/flag_es.png", -1, -1),
    )
)

internal val Res.drawable.flag_fr: DrawableResource
  get() = CommonMainDrawable0.flag_fr

private fun init_flag_fr(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:flag_fr",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/flag_fr.png", -1, -1),
    )
)

internal val Res.drawable.flag_it: DrawableResource
  get() = CommonMainDrawable0.flag_it

private fun init_flag_it(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:flag_it",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/flag_it.png", -1, -1),
    )
)

internal val Res.drawable.flag_sr: DrawableResource
  get() = CommonMainDrawable0.flag_sr

private fun init_flag_sr(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:flag_sr",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/flag_sr.png", -1, -1),
    )
)

internal val Res.drawable.giraffe: DrawableResource
  get() = CommonMainDrawable0.giraffe

private fun init_giraffe(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:giraffe",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/giraffe.png", -1, -1),
    )
)

internal val Res.drawable.ic_help_circle: DrawableResource
  get() = CommonMainDrawable0.ic_help_circle

private fun init_ic_help_circle(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_help_circle",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/ic_help_circle.xml", -1, -1),
    )
)

internal val Res.drawable.ic_launcher_background: DrawableResource
  get() = CommonMainDrawable0.ic_launcher_background

private fun init_ic_launcher_background(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_launcher_background",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/ic_launcher_background.xml", -1, -1),
    )
)

internal val Res.drawable.ic_launcher_foreground: DrawableResource
  get() = CommonMainDrawable0.ic_launcher_foreground

private fun init_ic_launcher_foreground(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_launcher_foreground",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/ic_launcher_foreground.xml", -1, -1),
    )
)

internal val Res.drawable.ic_radio_selector: DrawableResource
  get() = CommonMainDrawable0.ic_radio_selector

private fun init_ic_radio_selector(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_radio_selector",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/ic_radio_selector.xml", -1, -1),
    )
)

internal val Res.drawable.koala: DrawableResource
  get() = CommonMainDrawable0.koala

private fun init_koala(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:koala",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/koala.png", -1, -1),
    )
)

internal val Res.drawable.leo: DrawableResource
  get() = CommonMainDrawable0.leo

private fun init_leo(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:leo",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/leo.png", -1, -1),
    )
)

internal val Res.drawable.list_selector: DrawableResource
  get() = CommonMainDrawable0.list_selector

private fun init_list_selector(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:list_selector",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/list_selector.xml", -1, -1),
    )
)

internal val Res.drawable.loki: DrawableResource
  get() = CommonMainDrawable0.loki

private fun init_loki(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:loki",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/loki.png", -1, -1),
    )
)

internal val Res.drawable.raccoon: DrawableResource
  get() = CommonMainDrawable0.raccoon

private fun init_raccoon(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:raccoon",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/raccoon.png", -1, -1),
    )
)

internal val Res.drawable.refresh: DrawableResource
  get() = CommonMainDrawable0.refresh

private fun init_refresh(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:refresh",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/refresh.png", -1, -1),
    )
)

internal val Res.drawable.refresh_frame: DrawableResource
  get() = CommonMainDrawable0.refresh_frame

private fun init_refresh_frame(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:refresh_frame",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/refresh_frame.xml", -1, -1),
    )
)

internal val Res.drawable.robot: DrawableResource
  get() = CommonMainDrawable0.robot

private fun init_robot(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:robot",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/robot.png", -1, -1),
    )
)

internal val Res.drawable.spinner_item_background: DrawableResource
  get() = CommonMainDrawable0.spinner_item_background

private fun init_spinner_item_background(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:spinner_item_background",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/spinner_item_background.xml", -1, -1),
    )
)

internal val Res.drawable.squirrel: DrawableResource
  get() = CommonMainDrawable0.squirrel

private fun init_squirrel(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:squirrel",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/squirrel.png", -1, -1),
    )
)

internal val Res.drawable.thunder: DrawableResource
  get() = CommonMainDrawable0.thunder

private fun init_thunder(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:thunder",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/thunder.png", -1, -1),
    )
)

internal val Res.drawable.tooltip_bg: DrawableResource
  get() = CommonMainDrawable0.tooltip_bg

private fun init_tooltip_bg(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:tooltip_bg",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/tooltip_bg.xml", -1, -1),
    )
)

internal val Res.drawable.warmachine: DrawableResource
  get() = CommonMainDrawable0.warmachine

private fun init_warmachine(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:warmachine",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/kotlinproject.composeapp.generated.resources/drawable/warmachine.png", -1, -1),
    )
)
